const DEFAULT_OPTIONS = {
  top: 0,
  left: 0,
  behavior: 'smooth'
};

const scrollTo = (customOptions = {}) => {
  const options = { ...DEFAULT_OPTIONS, ...customOptions };
  try {
    window.scrollTo(options);
  } catch (e) {
    window.console && console.log(e);
  }
};
const smoothScroll = e => {
  e.preventDefault();
  const id = e.currentTarget.href.split('#')[1];
  const top = document.querySelector(`#${id}`).offsetTop;
  scrollTo({ top });
};
export default scrollTo;
export { smoothScroll, scrollTo };
